import { InvitationScreen } from "@hakili/app-shell";

/**
 * `P0-CNW-027`: the console's mount of the shared acceptance screen.
 *
 * **A mount and not a screen**, for `00-SPINE` 6.3's reason: three apps writing
 * a password form would each get the API's rules subtly different. What belongs
 * to an app is where the accepted invitee goes next, and that is the callback
 * `App` supplies.
 *
 * The name distinguishes it from `invitation.tsx`, which is `P0-IDN-046`'s
 * operator CARD , an authenticated Hakili staff member reading the last token
 * minted for an address, in an environment with no mail sender. Different
 * caller, different authorisation, different screen.
 */
export function Invitation(props: {
  readonly token: string;
  readonly origin: string;
  readonly fetchImpl?: typeof globalThis.fetch;
  readonly onAccepted: (accessToken: string) => void;
}): React.JSX.Element {
  return <InvitationScreen {...props} />;
}
